module.exports = __webpack_public_path__ + "static/media/favicon.c92b85a5.ico";


//////////////////
// WEBPACK FOOTER
// ./src/img/favicon.ico
// module id = 625
// module chunks = 0